import { getJSON } from "../request";
import { getMoguoCdnUrl } from "@saas/components/src/utils/assets";

const isProd = process.env.NODE_ENV === "production";

// 机构入驻页面配置
export const getOrgSettledJson = () =>
  getJSON(
    getMoguoCdnUrl(`/${isProd ? "" : "Test/"}cdn/json/org-settled.json`)
  );
